/**
 * Emergency numbers for the Almería region.
 * Every entry uses an i18n key for its name/description so all text is translatable.
 * Numbers themselves are universal — do not translate.
 */

export const EMERGENCY_NUMBERS = [
  {
    id: '112',
    number: '112',
    nameKey: 'emergency.euEmergency',
    descKey: 'emergency.euEmergencyDesc',
    category: 'primary',
    icon: 'AlertTriangle',
  },
  {
    id: 'policia-nacional',
    number: '091',
    nameKey: 'emergency.nationalPolice',
    descKey: 'emergency.nationalPoliceDesc',
    category: 'police',
    icon: 'Shield',
  },
  {
    id: 'guardia-civil',
    number: '062',
    nameKey: 'emergency.guardiaCivil',
    descKey: 'emergency.guardiaCivilDesc',
    category: 'police',
    icon: 'Shield',
  },
  {
    id: 'policia-local',
    number: '092',
    nameKey: 'emergency.localPolice',
    descKey: 'emergency.localPoliceDesc',
    category: 'police',
    icon: 'Shield',
  },
  {
    id: 'medical',
    number: '061',
    nameKey: 'emergency.medical',
    descKey: 'emergency.medicalDesc',
    category: 'medical',
    icon: 'Heart',
  },
  {
    id: 'fire',
    number: '080',
    nameKey: 'emergency.fire',
    descKey: 'emergency.fireDesc',
    category: 'fire',
    icon: 'Flame',
  },
  {
    id: 'violence',
    number: '016',
    nameKey: 'emergency.dvSupport',
    descKey: 'emergency.dvSupportDesc',
    category: 'support',
    icon: 'Phone',
  },
  {
    id: 'torrecardenas',
    number: '+34950016000',
    displayNumber: '+34 950 01 60 00',
    nameKey: 'emergency.torrecardenas',
    descKey: 'emergency.torrecardenasDesc',
    category: 'medical',
    icon: 'Heart',
  },
  {
    id: 'uk-consulate',
    number: '+34902109356',
    displayNumber: '+34 902 10 93 56',
    nameKey: 'emergency.ukConsulate',
    descKey: 'emergency.ukConsulateDesc',
    category: 'consulate',
    icon: 'Globe',
  },
  {
    id: 'ie-consulate',
    number: '+34914364093',
    displayNumber: '+34 914 36 40 93',
    nameKey: 'emergency.ieConsulate',
    descKey: 'emergency.ieConsulateDesc',
    category: 'consulate',
    icon: 'Globe',
  },
];
